import googleMapsStyles from './googlemapsStyles'
import googleMapsMarkers from './googleMapsMarkers'

export default class GoogleMapsConfig {
    constructor() {

    }

    static defaultMarker () {
        return {lat: 39.6636811584475, lng: -2.5850957328590884}
    }

    static styles () {
        return googleMapsStyles.customStyles
    }

    static stylesInside () {
        return googleMapsStyles.customStylesInside
    }

    static markerDefault () {
        return googleMapsMarkers.markerUrlIconDefault
    }

    static markerBlack () {
        return googleMapsMarkers.markerUrlIconBlack
    }

    static markerWhite () {
        return googleMapsMarkers.markerUrlIconWhite
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/factories/googlemaps/index.js